<template>
    <div class="styled-textarea">
        <label class="styled-textarea__label"
               :class="{
               'styled-textarea__label--focus': focus,
               'styled-textarea__label--filled': value.length ,
               'styled-textarea__label--valid': valid,
               'styled-textarea__label--error': error
               }"
               v-if="label">{{ label }}</label>
        <textarea :rows="rows"
                  type="text"
                  ref="input"
                  class="styled-textarea__input"
                  :class="{'eda-styled-textarea--invisible': !visible}"
                  :value="value"
                  @focus="focus = true"
                  @blur="focus = false"
                  @input="emit()">
        </textarea>
    </div>
</template>


<script>
  export default {
    inject: ['$validator'],
    name: "EdaStyledTextarea",
    props: {
      type: { type: String, default: "text" },
      label: { type: String, default: "" },
      value: { type: String, default: "" },
      visible: { type: Boolean, default: true },
      inputMask: { type: String, default: "" },
      darkTheme: { type: Boolean, default: false },
      rows: { type: Number, default: 4 },
      validation: { type: String, default: null }

    },
    data() {
      return {
        focus: false,
      }
    },
    methods: {
      emit() {
        this.$emit('input', this.$refs.input.value)
      }
    },
    computed: {
      name() {
        return this.label;
      },
      error() {
        return this.errors.has(this.name) && !this.focus;
      },
      valid() {
        return !this.errors.has(this.name) && this.value.length;
      }
    }
  }
</script>

<style lang="scss">
    .styled-textarea {
        position: relative;
        overflow: hidden;

        &__input {

            padding: 2.5em 2em 1.5em 1.5em;
            background-color: #EEE;
            border-radius: 1.5em;
            width: 100%;
            min-width: 100%;
            max-width: 100%;
            margin: 0.3em 0;
            border: none;
            opacity: 1;
            -webkit-appearance: none;
            outline: none;
            max-height: 20em;
            transition: all 0.2s cubic-bezier(.5, 0, 0, 1);

            &--invisible {
                max-height: 0em;
                padding: 0 1.5em;
                opacity: 0;
                margin: 0;
            }

        }

        .styled-textarea__label {

            transform-origin: top right;
            pointer-events: none;
            position: absolute;
            color: #AAA;
            font-size: 0.9em;
            font-weight: 300;
            width: 100%;
            text-align: left;
            top: 2em;
            left: 2em;
        }

        .styled-textarea__label--filled,
        .styled-textarea__label--focus {
            display: block;
            transition: all 0.2s ease;
            animation: comearound 0.2s forwards;
            word-break: keep-all;
            text-align: right;
            padding-right: 2em;
        }

        .styled-textarea__label--filled {
            color: #CCC;
        }

        .styled-textarea__label--focus {
            color: #00B27C;
        }

        .styled-textarea__label--error {
            color: red;
        }

        @keyframes comearound {
            0% {
                opacity: 0;
                left: 0%;
                transform: translate(0%, -50%);
            }
            25% {
                left: 0%;
                transform: translate(-150%, -50%);
            }
            50% {
                left: 100%;
                opacity: 0;
                transform: translate(150%, -50%);
            }
            100% {
                left: 100%;
                font-size: 0.8em;
                transform: translate(-100%, -50%);
            }
        }

    }


</style>